import React from "react";
import "./Beginner_Guide.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";

function Beginner_Guide() {
  return (
    <>
      <section className="Beginner_Guide">
        <Common_white_header headingText={"Beginner Guide"} />
        <div className="container">
          <div className="img_holder">
            <img
              className="guide_img"
              src="/assets/images/beginner_guide/Beginner_Guide.png"
              alt="guide img"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Beginner_Guide;
